export const BASIC_LOGIN = 'BASIC';
export const AD_AZURE_LOGIN = 'AD_AZURE';
export const TWO_FA_LOGIN = 'TWO_FA';